<template>
  <div>
    <Navbar></Navbar>
    <div class="section_1">
      <div class="title">
        Contact Us
      </div>
      <div class="list-info">
        <div class="item">
          <div class="img">
            <img style="width: 72px;" src="@/assets/2.0/icon-05.svg" />
          </div>
          <div class="text">
            <p>Phone:  ＋1 (858) 366-3765</p>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img style="width: 61px;" src="@/assets/2.0/icon-06.svg" />
          </div>
          <div class="text">
            <p>Address: 9920 Pacific Heights Blvd,</p>
              <p>One Pacific Heights, Suite 410,</p>
                <p>San Diego, CA 92121</p>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img style="width: 69px;"  src="@/assets/2.0/icon-07.svg" />
          </div>
          <div class="text">
            <p>Email: support@smwmed.com</p>
          </div>
        </div>
      </div>
    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";


export default {
  name: "index",
  components: {
    Navbar,
    FooterDom
  },
  data() {
    return {

    };
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
.section_1{
  width: 100%;

  background: #ECEEEF;

  .title{
    font-size: 80px;
    color: #4FC78B;
    padding-top: 80px;
    text-align: center;
    margin-bottom: 120px;
  }
  .list-info{
    display: flex;
    justify-content: center;
    padding-bottom: 120px;
    .item{
      border-right: 1px dashed #494A4A;
      text-align: center;
      flex-shrink: 1;
      padding: 0 50px;
      &:last-child{
        border-right: none;
      }
      .img{
        height: 100px;
        margin-top: 10px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .text{
        font-size: 28px;
        p{
          text-align: center;
          margin-bottom: 10px;
        }
      }
    }
  }
}
/* 桌面显示器，小于 1200px） */
@media (max-width: 1200px) {
  .section_1{
    .list-info {
      .item {
        .text{
          font-size: 24px;
        }
      }
    }
  }
}
/* 桌面显示器，小于 992px） */
@media (max-width: 992px) {
  .section_1{
    .list-info {
      .item {
        .text{
          font-size: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/support.vue